module.exports = __webpack_public_path__ + "img/Sindiloto.bcf029db.png";